import $ from 'jquery'
import { FontAwesomeIcon } from '../../../../../CommonComponents/AssetsHelper';
import { Link } from 'react-router-dom';

const NeedHelp =({text,videoUrl,supportLink})=>{
    const addSupportLinkFun = (supportLink) =>{
        if(supportLink !== null && supportLink !== '' && supportLink !== 'undefined' && supportLink !== '#'){
            setTimeout(() => {
                $('.lity-container')
                .append($("<div class='lity_read_more w-100 justify-content-center pt-5'><a class='btn btn-primary' href='"+supportLink+"' target='_blank'>Read More</a></div>").hide().fadeIn(500));
            }, 200);
        }else{
            return false
        }
    }

    return <div className="need_help__">
                {videoUrl !== '' || supportLink !== '' ? <p className="mb-0">
                    {text}
                    <a href={videoUrl} className="ms-1" data-lity onClick={()=>addSupportLinkFun(supportLink)}>
                        <FontAwesomeIcon type={'regular'} icon={'circle-play'} iconClass={'text-gray-500'} />
                        <span> Watch Video</span>
                    </a>
                </p>
                : null}
            </div>
}

export default NeedHelp;